
export class Region {
  regionId: number;
  regionName: string;

  constructor(json?: any) {
    this.regionId = json.regionId;
    this.regionName = json.regionName;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/Region.ts